import { useMutation, useQuery } from '@tanstack/react-query';

import { IAbbreviationWirePayload } from 'components/Theme/GeneralSettings/generalTheme.types';

import { EQueryKeys } from '../constants/enums';
import useAxios from '../hooks/useAxios';

import { EApiRoutes, fetchConfig, getApiRouteOrMock } from './api.utils';

export type IAbbreviationSettingsPayload = IAbbreviationWirePayload;

export default function useAbbreviationSettings(currentPublisherId?: string) {
  const axios = useAxios();

  const getAbbreviationSettings = useQuery<IAbbreviationWirePayload, Error>(
    {
      ...fetchConfig.general,
      retry: false,
      queryKey: [EQueryKeys.ABBREVIATION_SETTINGS + (currentPublisherId ?? '')],
      queryFn: async () =>
        await axios.get(
          getApiRouteOrMock(EApiRoutes.ABBREVIATION_SETTINGS),
          {},
          currentPublisherId ? { 'x-publishers': currentPublisherId } : undefined
        ),
      enabled: !!currentPublisherId
    }
  );

  const updateAbbreviationSettings = useMutation(
    async (payload: IAbbreviationSettingsPayload) =>
      await axios.put(
        getApiRouteOrMock(EApiRoutes.ABBREVIATION_SETTINGS),
        payload,
        currentPublisherId ? { 'x-publishers': currentPublisherId } : undefined
      )
  );

  return { getAbbreviationSettings, updateAbbreviationSettings };
}
